// Helpers for the Employee Portal date/time handling.
// Zoho expects: `DD-Mmm-YYYY hh:mm AM/PM`  — e.g. "15-Oct-2026 07:30 AM".

const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

/** Current date in Asia/Kolkata as a {y,m,d} object. */
export const istToday = () => {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  return {
    y: Number(get("year")),
    m: Number(get("month")),
    d: Number(get("day")),
  };
};

/** Returns an ISO yyyy-mm-dd string for N days from IST today (0 = today). */
export const istDateInputStr = (offsetDays = 0) => {
  const { y, m, d } = istToday();
  // Build a UTC date at IST noon to safely offset by days without TZ drift.
  const dt = new Date(Date.UTC(y, m - 1, d, 12, 0, 0));
  dt.setUTCDate(dt.getUTCDate() + offsetDays);
  const yy = dt.getUTCFullYear();
  const mm = String(dt.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(dt.getUTCDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
};

/** Converts a yyyy-mm-dd + HH:MM (24h) to Zoho's "DD-Mmm-YYYY hh:mm AM/PM". */
export const toZohoDateTime = (ymd, hhmm) => {
  if (!ymd || !hhmm) return "";
  const [y, m, d] = ymd.split("-").map(Number);
  const [H, M] = hhmm.split(":").map(Number);
  if (!y || !m || !d || Number.isNaN(H) || Number.isNaN(M)) return "";
  const period = H >= 12 ? "PM" : "AM";
  let h12 = H % 12;
  if (h12 === 0) h12 = 12;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d)}-${MONTHS[m - 1]}-${y} ${pad(h12)}:${pad(M)} ${period}`;
};

/** Default end-of-day time (shop close). */
export const SHOP_CLOSE = "19:30"; // 07:30 PM

/** Pickup-point → shop open time (24h). */
export const openingTime = (pickup) =>
  pickup === "Manipal" ? "09:00" : "07:30";
